import { css, styled } from 'styled-components';

import { theme } from '../../../styles';

type LabelProps = {
  children: React.ReactNode;
  errorVariant?: 'light' | 'dark';
  hasError: boolean;
  hasPreambleIcon?: boolean;
  id: string;
  labelColor?: string;
  hideOnFocus?: boolean;
};

const StyledLabel = styled.label<{
  errorVariant?: string;
  hasError: boolean;
  hasPreambleIcon?: boolean;
  labelColor?: string;
  hideOnFocus?: boolean;
}>`
  ${theme.typography.textStandard}
  display: flex;
  padding-bottom: 10px;
  align-items: center;
  color: ${theme.colors.black70};
  pointer-events: none;
  background-color: transparent;
  ${props =>
    props.hideOnFocus &&
    css`
      display: none;
    `}
`;

export const Label = ({
  children,
  errorVariant = 'light',
  hasError,
  hasPreambleIcon,
  id,
  labelColor,
  hideOnFocus = false,
}: LabelProps) => (
  <StyledLabel
    errorVariant={errorVariant}
    hasError={hasError}
    hasPreambleIcon={hasPreambleIcon}
    htmlFor={id}
    labelColor={labelColor}
    hideOnFocus={hideOnFocus}
  >
    {children}
  </StyledLabel>
);
